<template>
  <div class="auth-wrapper auth-v2">
    <!-- Background elements -->
    <div class="bg-element bg-element-1"></div>
    <div class="bg-element bg-element-2"></div>
    <div class="bg-element bg-element-3"></div>
    <div class="bg-element bg-element-4"></div>
    <div class="bg-element bg-element-5"></div>

    <div class="auth-inner">
      <div class="login-container">
        <div class="logo-container text-center mb-4">
          <b-img fluid :src="logoUrl" alt="fbr-invoices" width="200px" class="mb-4" />
        </div>

        <!-- form -->
        <validation-observer ref="loginValidation">
          <b-form class="auth-login-form" @submit.prevent="mylogin">
            <!-- email -->
            <b-form-group label="Email" label-for="login-email">
              <validation-provider #default="{ errors }" name="Email" rules="required|email">
                <b-form-input
                  id="login-email"
                  v-model="ulogin.email"
                  :state="errors.length > 0 ? false : null"
                  name="login-email"
                  placeholder="Enter your email"
                  class="login-input"
                />
                <small class="text-danger error-text">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password field -->
            <b-form-group label="Password" label-for="login-password">
              <validation-provider #default="{ errors }" name="Password" rules="required">
                <b-input-group class="input-group-merge">
                  <b-form-input
                    id="login-password"
                    v-model="ulogin.password"
                    :state="errors.length > 0 ? false : null"
                    :type="passwordFieldType"
                    name="login-password"
                    placeholder="············"
                    class="login-input"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger error-text">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <!-- <div class="d-flex justify-content-between mb-3">
              <b-form-checkbox id="remember-me" v-model="status" name="checkbox-1">
                Remember me
              </b-form-checkbox>
              <b-link :to="{ name: 'auth-forgot-password-v2' }" class="forgot-link">
                Forgot password?
              </b-link>
            </div> -->

            <!-- submit buttons -->
            <b-button type="submit" block :disabled="loading" class="login-button">
              <span v-if="!loading">Login</span>
              <span v-else class="d-flex align-items-center justify-content-center">
                <b-spinner small class="mr-1"></b-spinner>
                <span>Logging in...</span>
              </span>
            </b-button>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
} from 'bootstrap-vue';
import { required, email } from '@validations';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import store from '@/store/index';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import useJwt from '@/auth/jwt/useJwt';
import { handleJwtLogin } from '@/auth/jwt/jwtIntegration';
import { getHomeRouteForLoggedInUser } from '@/auth/utils';

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      username: '',
      role: '',
      vendorId: 0,
      status: '',
      password: '',
      userEmail: '',
      logoImg: require('@/assets/images/logo/fbr-logo-black.png'),
      required,
      email,
      ulogin: {
        email: '',
        password: '',
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    logoUrl() {
      return this.logoImg;
    },
  },
  created() {
    this.$store.commit('appConfig/UPDATE_CONTENT_WIDTH', 'full');
  },
  methods: {
    mylogin() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.loading = true;
          var axios = require('axios');
          var config = {
            method: 'post',
            url: process.env.VUE_APP_API_URL + 'Users/Login',
            data: {
              username: this.ulogin.email,
              password: this.ulogin.password,
            },
          };

          axios(config)
            .then((response) => {
              console.log('Full API Response:', JSON.stringify(response.data, null, 2));
              let resp = response.data.data;

              if (response.data.status == 'success') {
                console.log('User status:', resp.user.status);
                console.log('User forms:', resp.user.forms);
                console.log('Forms type:', typeof resp.user.forms);
                console.log('Forms length:', resp.user.forms ? resp.user.forms.length : 'undefined');
                if ((resp.user.status == 'active' || resp.user.status == 'Active') && resp.user.forms && resp.user.forms !== 'null' && resp.user.forms !== '') {
                  console.log('USER RESPONSE:', JSON.stringify(response.data, null, 2));

                  // save password entered
                  this.$store.commit('user/SET_PASS_ENTERED', this.ulogin.password);

                  // Use the new user module to store user data
                  this.$store.dispatch('user/login', {
                    token: resp.token,
                    user: resp.user,
                  });
                  this.$store.commit('setToken', resp.token);
                  // console.log(this.$store.state.user.userRights);

                  // set rights object for auth routes
                  console.log('Store userRights:', this.$store.state.user.userRights);
                  console.log('Raw forms data:', resp.user.forms);
                  let rights = {};
                  
                  if (this.$store.state.user.userRights && this.$store.state.user.userRights.length > 0) {
                    console.log('Using userRights from store');
                    this.$store.state.user.userRights.forEach((el) => {
                      if (el.children && el.children.length > 0) {
                        el.children.forEach((ch) => {
                          rights[ch.route] = { ...ch };
                        });
                      }
                    });
                  } else {
                    console.log('No userRights found in store, trying to parse forms directly');
                    // Try to parse forms directly if store doesn't have userRights yet
                    if (resp.user.forms) {
                      try {
                        const formsData = typeof resp.user.forms === 'string' ? JSON.parse(resp.user.forms) : resp.user.forms;
                        console.log('Parsed forms data:', formsData);
                        formsData.forEach((el) => {
                          if (el.children && el.children.length > 0) {
                            el.children.forEach((ch) => {
                              console.log('Adding route:', ch.route, ch);
                              rights[ch.route] = { ...ch };
                            });
                          }
                        });
                      } catch (error) {
                        console.error('Error parsing forms:', error);
                      }
                    }
                  }
                  
                  console.log('Final parsed rights:', rights);
                  console.log('Forms data route names:', Object.keys(rights));
                  this.$store.commit('user/SET_AUTH_ROUTES', rights);
                  console.log('Store authRoutes after commit:', this.$store.state.user.authRoutes);

                  this.loading = false;

                  // Set up ability system first to allow navigation
                  const abilityData = {
                    action: 'manage',
                    subject: 'all'
                  };
                  
                  // Update ability
                  this.$ability.update([abilityData]);

                  // Use JWT auth system
                  useJwt
                    .login({
                      email: 'admin@demo.com',
                      password: 'admin',
                    })
                    .then((jwtResponse) => {
                      // Use our integration function to handle JWT login
                      const userData = handleJwtLogin(jwtResponse);

                      // Update ability
                      this.$ability.update(userData.ability);

                      // Update cart items count
                      this.$store.commit(
                        'app-ecommerce/UPDATE_CART_ITEMS_COUNT',
                        userData.extras.eCommerceCartItemsCount
                      );

                      // Redirect to FBR dashboard route (known working route)
                      console.log('=== AUTH ROUTES:', this.$store.state.user.authRoutes);
                      console.log('=== Redirecting to dashboard');
                      this.$router.replace({ name: 'dashboard' });
                      // Redirect to home route
                      // this.$router.replace(
                      //   getHomeRouteForLoggedInUser(userData.role)
                      // );
                      // .then(() => {
                      //   this.$toast({
                      //     component: ToastificationContent,
                      //     position: "top-right",
                      //     props: {
                      //       title: `Welcome ${
                      //         userData.fullName || "Administrator"
                      //       }`,
                      //       icon: "CoffeeIcon",
                      //       variant: "success",
                      //       text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                      //     },
                      //   });
                      // });
                    })
                    .catch((error) => {
                      console.log('USE JWT ERROR', error);
                    });
                } else if (resp.user.status == 'pending' || resp.user.status == 'Pending') {
                  Swal.fire({
                    title: 'Please wait..',
                    text: 'Your account is in process for approval.',
                    icon: 'info',
                    iconColor: '#FB595f',
                    confirmButtonColor: '#FB595f',
                  }).then((res) => {
                    this.loading = false;
                  });
                } else if (
                  resp.user.status == 'declined' ||
                  resp.user.status == 'Declined' ||
                  resp.user.status == 'suspended' ||
                  resp.user.status == 'Suspended'
                ) {
                  console.log('declined');
                  Swal.fire({
                    title: 'Failed!',
                    text: 'Your account approval is canceled for some reasons.',
                    icon: 'warning',
                    iconColor: '#FB595f',
                    confirmButtonColor: '#FB595f',
                  }).then((res) => {
                    this.loading = false;
                  });
                  this.loading = false;
                } else if (resp.user.status !== 'active' && resp.user.status !== 'Active') {
                  console.log('User status not active:', resp.user.status);
                  Swal.fire({
                    title: 'Account Status Issue',
                    text: `Your account status is: ${resp.user.status}. Please contact administrator.`,
                    icon: 'warning',
                    iconColor: '#FB595f',
                    confirmButtonColor: '#FB595f',
                  }).then((res) => {
                    this.loading = false;
                  });
                } else if (!resp.user.forms) {
                  console.log('User forms missing');
                  Swal.fire({
                    title: 'Account Setup Issue',
                    text: 'Your account is not properly configured. Please contact administrator.',
                    icon: 'warning',
                    iconColor: '#FB595f',
                    confirmButtonColor: '#FB595f',
                  }).then((res) => {
                    this.loading = false;
                  });
                } else {
                  console.log('Error!');
                  Swal.fire({
                    title: 'Error!',
                    text: 'Please check you email or password is correct.',
                    icon: 'error',
                    iconColor: '#FB595f',
                    confirmButtonColor: '#FB595f',
                  }).then((res) => {
                    this.loading = false;
                  });
                }
              } else {
                this.$bvToast.toast('Please check your email or password is correct.', {
                  title: 'Error!',
                  variant: 'danger',
                  solid: true,
                });
                return (this.loading = false);
              }
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.auth-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f8f8;
  position: relative;
  overflow: hidden;
}

.auth-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.login-container {
  width: 100%;
  max-width: 450px;
  background-color: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 8px 30px 0 rgba(0, 0, 0, 0.1);
}

.login-input {
  background-color: white !important;
  border: 1px solid #e8e8e8 !important;
  color: #2c2c2c !important;
  padding: 0.75rem 1rem;
  height: calc(1.5em + 1.3rem + 2px);
}

.login-input::placeholder {
  color: #b4b4b4 !important;
}

.login-button {
  background-color: #7367f0 !important;
  border-color: #7367f0 !important;
  padding: 0.75rem !important;
  margin-top: 0.5rem;
}

.input-group-text {
  background-color: white !important;
  border: 1px solid #e8e8e8 !important;
  color: #6e6b7b !important;
}

label {
  color: #5e5873 !important;
  margin-bottom: 0.5rem;
}

.custom-control-label {
  color: #5e5873 !important;
}

.forgot-link {
  color: #7367f0 !important;
}

.custom-control-label::before {
  background-color: white !important;
  border-color: #d8d6de !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #7367f0 !important;
}

.error-text {
  color: #ea5455 !important;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  border-color: #ea5455 !important;
}

/* Background elements */
.bg-element {
  position: absolute;
  border: 2px solid rgba(115, 103, 240, 0.05);
  border-radius: 10px;
  opacity: 0.15;
}

.bg-element-1 {
  width: 350px;
  height: 350px;
  bottom: -80px;
  right: -80px;
  transform: rotate(45deg);
  background-color: rgba(115, 103, 240, 0.05);
}

.bg-element-2 {
  width: 250px;
  height: 250px;
  top: 8%;
  left: 12%;
  transform: rotate(30deg);
  background-color: rgba(115, 103, 240, 0.05);
}

.bg-element-3 {
  width: 180px;
  height: 180px;
  bottom: 15%;
  left: 20%;
  transform: rotate(15deg);
  background-color: rgba(115, 103, 240, 0.05);
}

.bg-element-4 {
  width: 120px;
  height: 120px;
  top: 60%;
  right: 15%;
  transform: rotate(-25deg);
  background-color: rgba(115, 103, 240, 0.05);
}

.bg-element-5 {
  width: 80px;
  height: 80px;
  top: 30%;
  right: 25%;
  transform: rotate(10deg);
  background-color: rgba(115, 103, 240, 0.05);
}

.auth-login-form {
  margin-top: 1rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.logo-container {
  margin-bottom: 1.5rem !important;
}
</style>
